import type { ActionType, TableEditorAction } from '@stratumn/studio-shared';

import { ActionModel } from './action.model';

export class TableEditorActionModel extends ActionModel {
  public actionType = 'TABLE_EDITOR' as const satisfies ActionType;

  get metadata() {
    return this._metadata as TableEditorAction['metadata'];
  }
}
